import firebase from 'firebase'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBYHz3wnPbF9wezRTvsoI0TJnuo-rXFffA",
    authDomain: "ultim2020.firebaseapp.com",
    databaseURL: "https://ultim2020.firebaseio.com",
    projectId: "ultim2020",
    storageBucket: "ultim2020.appspot.com",
    messagingSenderId: "862975306841",
    appId: "1:862975306841:web:a2a0c70e139acf89a41548",
    measurementId: "G-T41GLHV63F"
};

if(!firebase.apps || firebase.apps.length === 0){
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();
}

